module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDMwIDI0Ij4KICA8cGF0aCBpZD0iSWNvbl9tYXRlcmlhbC1lbWFpbCIgZGF0YS1uYW1lPSJJY29uIG1hdGVyaWFsLWVtYWlsIiBkPSJNMzAsNkg2QTMsMywwLDAsMCwzLjAxNSw5TDMsMjdhMy4wMDksMy4wMDksMCwwLDAsMywzSDMwYTMuMDA5LDMuMDA5LDAsMCwwLDMtM1Y5QTMuMDA5LDMuMDA5LDAsMCwwLDMwLDZabTAsNkwxOCwxOS41LDYsMTJWOWwxMiw3LjVMMzAsOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC02KSIgZmlsbD0iIzAwZTFlZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_mail.svg
// module id = 0+ze
// module chunks = 1